import { remove, uniqueBy } from 'lodash'

const SET_TASKS = (state, tasks) => {
	state.tasks = tasks
}

const SET_TASK = (state, task) => {
	state.selectedTask = task
}

const REMOVE_TASK = (state, task) => {
	const tasks = [...state.tasks]
	
	remove(tasks, t => task.id === t.id)
	
	state.tasks = tasks
}

const SET_CLASSIFICATIONS = (state, tasks) => {
	let classifications = []
	
	tasks.forEach(function (task)
	{
		if (!classifications.hasOwnProperty(task.classification_id)) {
			classifications.push({
				id: task.classification_id,
				label: task.classification,
			})
		}
	})
	
	state.classifications = classifications
}

export default {
	SET_TASKS,
	SET_TASK,
	REMOVE_TASK,
	SET_CLASSIFICATIONS,
}
